import { AuthFailureEvent } from '../../domain/enums/auth-failure-event';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { PPL_DIALOG_DATA, PplDialogRef } from '@ppl/ui/dialog';
import { MemoizeLast } from '@ppl/utils/memoize.utils';
import { createDialogSuccessResponse, type DialogResponse } from '@ppl/utils/dialog.utils';


@Component({
  selector: 'ppl-signed-out-dialog',
  standalone: false,
  templateUrl: './signed-out-dialog.component.html',
  styleUrl: './signed-out-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignedOutDialogComponent {

  @MemoizeLast<SignedOutDialogComponent>(['data'])
  get message() {
    switch (this.data.statusCode) {
      case AuthFailureEvent.SessionExpiredByPolicy: // IP Whitelist. Session expired because of idle timeout, absolute timeout or daily logout time.
        return $localize`:@@AuthSignedOutDialogAutoLogout:You have been automatically signed out in accordance with your company's security policy. Please sign in again`;
      default:
        return $localize`:@@AuthSignedOutDialogSessionExpired:You have been automatically signed out by the system. Please sign in again`;
    }
  }

  constructor(
    private dialogRef: PplDialogRef<SignedOutDialogComponent, DialogResponse>,
    @Inject(PPL_DIALOG_DATA) public data: SignedOutDialogData
  ) { }

  onSignIn() {
    this.dialogRef.close(createDialogSuccessResponse());
  }
}

export interface SignedOutDialogData {
  statusCode?: number;
}
